import styled from 'styled-components'

export const Main = styled.div`
text-align:left;
padding:80px 150px;
@media screen and (max-width:768px){
    padding:10px;
}
`
export const Img = styled.img`
height:600px;
width:800px;
display:flex;
margin:auto;
border:1px solid grey;
padding:10px;
@media screen and (max-width:768px){
    height:300px;
    width:300px;
}
`
